type DietMenuCalorificBadgeProps = {
  calories: number;
};

export const DietMenuCalorificBadge = ({
  calories,
}: DietMenuCalorificBadgeProps) => (
  <div className="rounded-sm bg-brand-green-light2 px-3 py-1">
    <p>
      <span className="font-bold">{calories}</span> kcal
    </p>
  </div>
);
